"use strict";
/**
 * The inventory report's waterfall, line by line and in headlines (GH138).
 *
 * Pure functions shared by the backend (the waterfall, the PDF, the Excel) and the report screen, so a saved
 * report shows the same numbers on screen, in its PDF and in its Excel.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineExpiredLoss = lineExpiredLoss;
exports.lineUnexplainedLoss = lineUnexplainedLoss;
exports.waterfallHeadlines = waterfallHeadlines;
exports.reportLineKey = reportLineKey;
exports.overridesByLine = overridesByLine;
const round2 = (n) => Math.round(n * 100) / 100;
/**
 * What a line's expired units explain of its shortage: their value, up to the line's shortage.
 *
 * Only an «expired» line counts. Its expired units can be worth more than its shortage (March 2026, Urban,
 * OTROZOL: 2 expired, $150, against a shortage of 0.85, $63.75): the difference is stock that turned up in
 * the same line, and it must not cover the unexplained losses of other lines.
 */
function lineExpiredLoss(line) {
    if (line.classification !== "expired")
        return 0;
    return Math.max(0, Math.min(line.expiredValue, line.shrinkageValue));
}
/**
 * What a line adds to «sin explicar»: its shortage less what its expired units explain. Nothing for an
 * ignored line, a surplus, internal consumption or a negligible difference. Added up over the lines of a
 * waterfall, it gives that waterfall's `unexplained`.
 */
function lineUnexplainedLoss(line, isIgnored) {
    if (isIgnored || line.shrinkageValue <= 0)
        return 0;
    if (line.classification === "consumption" || line.classification === "negligible")
        return 0;
    return round2(line.shrinkageValue - lineExpiredLoss(line));
}
function waterfallHeadlines(w) {
    const unexplained = round2(Math.max(0, w.faltantes - w.consumption - w.expired));
    return {
        unexplained,
        totalLoss: round2(unexplained + w.expired),
        finalBalance: round2(unexplained - w.sobrantes),
        ignored: round2(w.baseFaltantes - w.faltantes),
    };
}
/** Key of a report line: one product in one branch. */
function reportLineKey(line) {
    return `${line.qvetCode}:${line.branch}`;
}
/**
 * The «ignorar» mark of each line, by `reportLineKey`. A mark without a branch covers every line of its
 * product; a mark on one branch covers that line only.
 */
function overridesByLine(lines, overrides) {
    const byLine = new Map();
    for (const o of overrides) {
        if (o.branch === null) {
            for (const line of lines) {
                if (line.qvetCode === o.qvetCode)
                    byLine.set(reportLineKey(line), o);
            }
        }
        else {
            byLine.set(reportLineKey({ qvetCode: o.qvetCode, branch: o.branch }), o);
        }
    }
    return byLine;
}
